import styled from 'styled-components';

export const SpacerRow = styled.div`
  width: 100%;
  height: ${(props) => props.theme.spacing.spacing5};
`;
